import { render, staticRenderFns } from "./SurfaceDesignPrintPlacementNew.vue?vue&type=template&id=73571410"
import script from "./SurfaceDesignPrintPlacementNew.vue?vue&type=script&lang=js"
export * from "./SurfaceDesignPrintPlacementNew.vue?vue&type=script&lang=js"
import style0 from "./SurfaceDesignPrintPlacementNew.vue?vue&type=style&index=0&id=73571410&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports